import logo from './logo.svg';
import './App.css';
// import { Navbar } from './components/Navbar/Navbar';
import Home from './components/Home';

function App() {
  return (  
    <div className="App">        
        <div><Home/></div>
        
      
     
    </div>
  );
}

export default App;
